"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Api = _interopRequireDefault(require("../../logic/api/Api"));

var _validate = _interopRequireDefault(require("validate.js"));

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var FormHandler = /*#__PURE__*/function () {
  /**
   * Constructor
   *
   * @param component
   * @param startingData
   */
  function FormHandler(component, model) {
    var _this = this;

    var customState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, FormHandler);

    this.model = model;
    this.component = component;
    this.callbacks = {
      submitError: [],
      submitSuccess: []
    };
    var startingData = model.getData(); // Set default component state

    component.state = _objectSpread({
      isLoading: false,
      submitStatus: false,
      record: startingData,
      errors: []
    }, customState); // Rewire componentWillUpdate

    var oldWillUpdate = component.componentWillUpdate;

    component.componentWillUpdate = function (nextProps, nextState) {
      _this.state = nextState;

      if (typeof oldWillUpdate === 'function') {
        oldWillUpdate(nextProps, nextState);
      }
    }; // Store state here


    this.state = component.state; // Map setState from component

    this.setState = function (param) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      component.setState(param, function () {
        _this.state = component.state;
        if (callback) callback();
      });
    };

    this.options = options;
  }
  /**
   * Get submit url
   *
   * @returns {null}
   */


  _createClass(FormHandler, [{
    key: "getSubmitUrl",
    value: function getSubmitUrl() {
      return this.model.getSubmitUrl();
    }
    /**
    * Handle submit
    *
    * @param event
    * @returns {boolean}
    */

  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this2 = this;

      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var shouldReject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new Promise(function (resolve, reject) {
        if (event) {
          event.preventDefault();
        } // Clear errors


        _this2.clearErrors(); // Client side validation


        if (!_this2.clientValidation()) {
          _this2.scrollToError();

          return;
        } // On before submit


        if (_this2.onBeforeSubmit() === false) {
          reject();
          return;
        }

        _this2.onBeforeSubmit(); // Call api to login


        _Api["default"].call(_this2.getSubmitUrl(), _this2.getSubmitData()).then(function (data) {
          _this2.onSubmitSuccess(data);

          resolve(data);
        }, function (error) {
          _this2.onSubmitError(error);

          if (shouldReject) {
            reject(error);
          }
        })["finally"](function () {
          _this2.onAfterSubmit();
        });
      });
    }
    /**
     * Called before submit
     */

  }, {
    key: "onBeforeSubmit",
    value: function onBeforeSubmit() {
      // Set loading
      this.setState({
        isLoading: true
      });
    }
    /**
     * Called after submit
     */

  }, {
    key: "onAfterSubmit",
    value: function onAfterSubmit() {
      this.setState({
        isLoading: false
      });
    }
    /**
     * Returns submit data to send over AJAX
     *
     * @returns {{}|record|*}
     */

  }, {
    key: "getSubmitData",
    value: function getSubmitData() {
      if (this.component.getSubmitData) {
        return this.component.getSubmitData(this.state.record);
      }

      return this.state.record;
    }
    /**
     * Called on ajax success
     *
     * @param data
     */

  }, {
    key: "onSubmitSuccess",
    value: function onSubmitSuccess(data) {
      var _this3 = this; // Parse response


      var submitStatus = false;

      if (data.success) {
        submitStatus = true;

        if (data.data && data.data.redirect) {
          window.location = data.data.redirect;
        }
      } // Set state


      this.setState({
        submitStatus: submitStatus,
        submitMessage: data.message
      });

      if (data.success) {
        this.callback('submitSuccess', data);

        if (this.component.onSubmitSuccess) {
          this.component.onSubmitSuccess(data);
        }
      }

      if (!data.success) {
        this.callback('submitError', data);

        if (this.component.onSubmitError) {
          this.component.onSubmitError(data);
        }

        this.handleServerErrors(data);
      } // Clear state


      setTimeout(function () {
        _this3.setState({
          submitMessage: null
        });
      }, 3000);
    }
    /**
     * Called on submit error
     *
     * @param error
     */

  }, {
    key: "onSubmitError",
    value: function onSubmitError(error) {
      // console.error('error', error);
      if (error.errors && error.errors.length) {
        this.setState({
          submitStatus: false,
          submitMessage: error.errors[0].message
        });
      }

      if (this.component.onSubmitError) {
        this.component.onSubmitError(error);
      }

      this.callback('submitError', error);
    }
    /**
     * Handle input change
     *
     * @param event
     */

  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var _this4 = this;

      var passedValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var name = null;
      var value = null;

      if (!event.target) {
        name = event;
        value = passedValue;
      } else {
        name = event.target.name;
        value = event.target.value;
      }

      this.setState(_objectSpread({}, this.state, {
        record: _objectSpread({}, this.state.record, _defineProperty({}, name, value))
      }), function () {
        _this4.callback('inputChange', {
          name: name,
          value: value
        });
      });

      if (passedValue !== '') {
        this.clearErrors();
      }
    }
    /**
     * Get submission status component
     *
     * @returns {string}
     */

  }, {
    key: "getSubmissionStatus",
    value: function getSubmissionStatus() {
      var submissionStatus = "";

      if (this.state.submitMessage) {
        submissionStatus = _react["default"].createElement("div", {
          className: "form-message"
        }, this.state.submitMessage);
      }

      return submissionStatus;
    }
    /**
     * Get form class component
     *
     * @returns {string}
     */

  }, {
    key: "getFormClass",
    value: function getFormClass() {
      var formClass = '';

      if (typeof this.state.submitStatus !== 'undefined') {
        formClass = this.state.submitStatus ? '' : 'form-error';
      }

      return formClass;
    }
    /**
     * Get loading component
     *
     * @returns {string}
     */
    // getLoadingComponent() {
    //   let loadingComponent = '';
    //   if (this.state.isLoading) {
    //     loadingComponent = <LoadingOverlay />;
    //   }
    //   return loadingComponent;
    // }

    /**
     * Invalidate field
     *
     * @param field
     * @param message
     */

  }, {
    key: "invalidateField",
    value: function invalidateField(field, message) {
      var errors = this.state.errors || [];
      errors.push({
        field: field,
        message: message
      });
      this.setState({
        errors: errors
      });
    }
  }, {
    key: "clearErrors",
    value: function clearErrors() {
      this.setState({
        errors: []
      });
      this.state.errors = [];
    }
  }, {
    key: "getErrors",
    value: function getErrors() {
      return this.state.errors;
    }
  }, {
    key: "validate",
    value: function validate() {
      this.clearErrors();
      return this.clientValidation();
    }
  }, {
    key: "clientValidation",
    value: function clientValidation() {
      var _this5 = this;

      var validationRules = this.model.getValidationRules(this.state.record);

      var data = _objectSpread({}, this.state.record);

      for (var k in data) {
        var value = data[k];

        if (typeof value === 'string' && value.trim() === "") {
          data[k] = null;
        }
      }

      var errors = _validate["default"].validate(data, validationRules, {
        fullMessages: false
      });

      for (var field in errors) {
        this.invalidateField(field, errors[field]);
      }

      var customErrors = this.model.customValidation(this.state.record);

      if (customErrors.length) {
        customErrors.forEach(function (error) {
          _this5.invalidateField(error.field, error.message);
        });
      }

      return this.getErrors().length === 0;
    }
  }, {
    key: "scrollToError",
    value: function scrollToError() {
      setTimeout(function () {
        if ((0, _jquery["default"])('.validation-message').length) {
          var firstError = (0, _jquery["default"])('.validation-message').first();

          if (firstError && firstError.offset()) {
            (0, _jquery["default"])('html, body').animate({
              scrollTop: firstError.offset().top - 200
            }, 500);
          }
        }
      }, 300);
    }
  }, {
    key: "on",
    value: function on(callbackName, callbackFunction) {
      if (!this.callbacks[callbackName]) {
        this.callbacks[callbackName] = [];
      }

      this.callbacks[callbackName].push(callbackFunction);
    }
  }, {
    key: "callback",
    value: function callback(callbackName, data) {
      if (!this.callbacks[callbackName]) return;
      var callbacks = this.callbacks[callbackName];

      for (var i = 0; i < callbacks.length; i++) {
        try {
          callbacks[i](data);
        } catch (e) {
          console.error(e);
        }
      }
    }
  }, {
    key: "handleServerErrors",
    value: function handleServerErrors(data) {
      var _this6 = this;

      if (!data || !data.errors || !data.errors.length) return;
      data.errors.forEach(function (error) {
        if (error.type === 'validation_error') {
          _this6.invalidateField(error.field, error.message);
        }
      });
    }
  }]);

  return FormHandler;
}();

exports["default"] = FormHandler;